// PrivateRoute.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate,useLocation } from 'react-router-dom';

// const PrivateRoute = ({ children }) => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const accessToken = useSelector((state) => state.accessToken);
//   console.log('accessToken',accessToken);
//   if(accessToken !=null && accessToken != "null")
//   {
//     dispatch(setAccessToken(accessToken));
//     return  children;
//   }
    
//   const params = new URLSearchParams(location.search);
//   const token = params.get('auth');
//   console.log('token',token);
//   if(token != null)
//   {
//     console.log('token',token);
//     dispatch(setAccessToken(token)); 
//     return children;
//   }
  
//   return <Navigate to={all_routes.signin} />;
// };
const ProtectiveRoutes = ({children}) => {
  console.log('start ProtectiveRoutes');
  const accessToken = useSelector((state) => state.accessToken);
  console.log('start ProtectiveRoutes accessToken',accessToken);
  if(!accessToken ) {
    return <Navigate to="/signin"/>
  }
  return children;
}

ProtectiveRoutes.propTypes = {
  children: PropTypes.any
};



export default ProtectiveRoutes;
